module.exports = __webpack_public_path__ + "static/media/inter.eaa1e58c.png";